var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"action link",attrs:{"target":"_blank","href":'https://whatismyipaddress.com/ip/'+_vm.ip}},[_vm._v(_vm._s(_vm.ip))])}
var staticRenderFns = []

export { render, staticRenderFns }